var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.71,6.29l-2-2-.71-.29h-3.28l-.77-2.32-.95-.68H8l-.95,.68-.77,2.32H3l-.71,.29L.29,6.29l-.29,.71v11l.29,.71,2,2,.71,.29H21l.71-.29,2-2,.29-.71V7l-.29-.71Zm-1.71,11.29l-1.41,1.41H3.41l-1.41-1.41V7.41l1.41-1.41h3.59l.95-.68,.77-2.32h6.56l.77,2.32,.95,.68h3.59l1.41,1.41v10.17ZM14.71,7.29l-.71-.29h-4l-.71,.29-2,2-.29,.71v4l.29,.71,2,2,.71,.29h4l.71-.29,2-2,.29-.71v-4l-.29-.71-2-2Zm.29,6.29l-1.41,1.41h-3.17l-1.41-1.41v-3.17l1.41-1.41h3.17l1.41,1.41v3.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/1772534745/media/icon-camera.54177d535909d74b5886e3af8b8c71a0.svg";
export { ForwardRef as ReactComponent };